module.exports = __webpack_public_path__ + "static/media/ronghejicheng.2189210.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/ronghejicheng.mp4
// module id = tc+/
// module chunks = 0